<div class="desktop">
    <div class="label">
        {{label}}
    </div>
    <div class="text">
        
    </div>
    <div class="value">
        <mat-slide-toggle [checked]="inputValue" (toggleChange)="emit()"></mat-slide-toggle>
    </div>
    <div class="action">

    </div>
</div>

<div class="mobile">
    <mat-form-field appearance="outline">
        <mat-label>{{label}}</mat-label>
        <input matInput placeholder="" [(ngModel)]="inputValue">
    </mat-form-field>
</div>